// extracted by mini-css-extract-plugin
module.exports = {"root":"IconButton_root__WP6uT","primary":"IconButton_primary__t13Hy","secondary":"IconButton_secondary__RCDkU","sm":"IconButton_sm__bvgEM","md":"IconButton_md__CsAU5"};